<div class="footer">
  <div class="footer-items small">
    <div class="footer-item">myCTCA Portal version {{version}}</div>
    <div class="footer-item">&copy; {{copyrightYear}} COH HoldCo Inc.</div>
  </div>
</div>
